import React, { useEffect, useRef } from "react";
import "./coach-landing.css";

const FEATURES = [
  {
    tag: "Todo de un vistazo",
    title: "Tu dashboard de coach",
    text: "Tus clientes, cuántos tienen plan y lo que te han pagado o te deben nada más entrar. Tu negocio, claro y ordenado.",
    bullets: ["Resumen de tu actividad", "Cobros de tus clientes y lo pendiente", "Últimos clientes y su plan"],
    img: "/assets/img/panel-dashboard.png",
    alt: "Dashboard del panel de coach de Wayo",
  },
  {
    tag: "Gestión de clientes",
    title: "Todos tus clientes en un solo sitio",
    text: "Ficha de cada cliente con sus objetivos, macros y progreso. Se acabó el Excel y el WhatsApp disperso.",
    bullets: ["Objetivos y macros por cliente", "Seguimiento del progreso", "Chat integrado con el cliente"],
    img: "/assets/img/panel-ficha-cliente.png",
    alt: "Ficha de cliente en el panel de Wayo Coach",
  },
  {
    tag: "Entrenamientos",
    title: "Crea rutinas profesionales en minutos",
    text: "Diseña planes con series, repeticiones y descansos, y asígnalos con el vídeo de cada ejercicio.",
    bullets: ["Biblioteca de ejercicios con vídeo", "Series, reps y descansos", "Rutinas reutilizables como plantillas"],
    img: "/assets/img/panel-entreno.png",
    alt: "Diseñador de rutinas en el panel de Wayo Coach",
  },
  {
    tag: "Nutrición con IA",
    title: "Planes de nutrición sin pelearte con Excel",
    text: "Monta menús con las calorías y macros calculados por IA. Tu cliente los ve en su móvil con las cantidades.",
    bullets: ["Calorías y macros automáticos", "Comidas e ingredientes", "Ajustado a su objetivo"],
    img: "/assets/img/panel-nutricion.png",
    alt: "Plan de nutrición en el panel de Wayo Coach",
  },
  {
    tag: "Calendario",
    title: "Cada día planificado para tu cliente",
    text: "Entrenos y comidas organizados en un calendario que tu cliente sigue desde su propia app.",
    bullets: ["Entrenos y comidas por día", "Vista semanal y mensual", "Sincronizado con la app del cliente"],
    img: "/assets/img/panel-calendario.png",
    alt: "Calendario del cliente en el panel de Wayo Coach",
  },
  {
    tag: "Tu negocio",
    title: "Controla el dinero de tu negocio",
    text: "Lo que ya te han pagado tus clientes, lo que queda pendiente y cómo evoluciona mes a mes. Sin cuota que te reste margen.",
    bullets: ["Facturación y comprobantes", "Cobrado y pendiente por cliente", "Evolución mes a mes"],
    img: "/assets/img/panel-negocio.png",
    alt: "Panel de negocio y facturación en Wayo Coach",
  },
];

export default function CoachProductTour() {
  const sectionRef = useRef(null);

  useEffect(() => {
    const rows = sectionRef.current
      ? sectionRef.current.querySelectorAll(".tour-row")
      : [];
    if (!("IntersectionObserver" in window)) {
      rows.forEach((r) => r.classList.add("is-visible"));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -60px 0px" }
    );
    rows.forEach((r) => io.observe(r));
    return () => io.disconnect();
  }, []);

  return (
    <section className="tour-section" id="tour" ref={sectionRef}>
      <div className="container">
        <div className="tour-header">
          <div className="section-tag">El producto por dentro</div>
          <h2 className="section-title">Mira el panel de coach por dentro</h2>
          <p className="section-subtitle">
            Un recorrido real por Wayo Coach: tus clientes, sus planes de entreno y nutrición, el
            calendario y tu facturación. Todo lo que otras plataformas cobran, aquí gratis.
          </p>
        </div>

        <div className="tour-rows">
          {FEATURES.map((f, i) => (
            <div className="tour-row" key={i}>
              <div className="tour-row-media">
                <div className="tour-row-media-inner">
                  {/* La primera captura entra casi al bajar del hero: si es lazy
                      se ve el hueco. El resto sí van diferidas. */}
                  {/* En movil se carga una version RECORTADA a mano de cada captura: la
                      ancha (2400x884) a 438px de ancho queda de 160px de alto y no se lee
                      nada. El recorte quita el menu lateral y la barra del navegador y se
                      queda con el titulo y las primeras tarjetas. */}
                  <picture>
                    <source media="(max-width: 900px)" srcSet={f.img.replace(".png", "-movil.png")} />
                    <img src={f.img} alt={f.alt} loading={i === 0 ? "eager" : "lazy"} />
                  </picture>
                </div>
              </div>
              <div className="tour-row-copy">
                <span className="tour-row-tag">{f.tag}</span>
                <h3>{f.title}</h3>
                <p>{f.text}</p>
                <ul>
                  {f.bullets.map((b, j) => (
                    <li key={j}>
                      <span className="tour-dot" /> {b}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        <p className="tour-note">El panel real de Wayo Coach. 100% gratis, sin límite de clientes.</p>
      </div>
    </section>
  );
}
